// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ot-1";
export var messageSideRight = "_ot-2";
export var orderLookupBubbleContainer = "_ot-0";
export var submitButton = "_ot-3";